import { Outlet } from "react-router-dom";
import Sidebar from "@/layout/Sidebar";
import Topbar from "@/layout/Topbar";
import DemoBanner from "@/demo/DemoBanner";
import BookingModal from "@/demo/BookingModal";
import TourPill from "@/demo/TourPill";
import CustomizeSidebarModal from "@/nav/CustomizeSidebarModal";

export default function AppLayout() {
  return (
    <div className="flex min-h-screen" data-testid="app-layout" style={{ background: "var(--bg-deep)" }}>
      <Sidebar />
      <div className="flex-1 flex flex-col" style={{ marginLeft: 240, background: "var(--bg-card)" }}>
        <Topbar />
        <DemoBanner />
        <main className="flex-1 px-8 py-8" data-testid="main-content">
          <Outlet />
        </main>
      </div>
      <BookingModal />
      <TourPill />
      <CustomizeSidebarModal />
    </div>
  );
}
